// Location detection for location-specific elements.
// @see https://shopify.dev/docs/storefronts/themes/markets/localization-discovery
(function() {
  async function detectVisitorLocation() {
    const response = await fetch(
      window.Shopify.routes.root +
        'browsing_context_suggestions.json' +
        '?country[enabled]=true' +
        `&country[exclude]=${window.Shopify.country}` +
        '&language[enabled]=true' +
        `&language[exclude]=${window.Shopify.language}`
    );

    if (!response.ok) return null;

    const data = await response.json();
    return data.detected_values?.country?.handle || null;
  }

  detectVisitorLocation().then(function(countryCode) {
    document.dispatchEvent(new CustomEvent('visitor:location', {
      detail: { countryCode: countryCode || 'US' }
    }));
  });
})();
